import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    DEBITO: {
        id: 'DEBITO',
        defaultMessage: 'Debit',
    },
    CREDITO: {
        id: 'CREDITO',
        defaultMessage: 'Credit',
    },
    'PRE-PAGO': {
        id: 'PRE-PAGO',
        defaultMessage: 'Prepaid',
    },
    'CREDITO ZERO-BALANCE': {
        id: 'CREDITO ZERO-BALANCE',
        defaultMessage: 'Zero balance credit',
    },
    'DEBITO ZERO-BALANCE': {
        id: 'DEBITO ZERO-BALANCE',
        defaultMessage: 'Zero balance debit',
    },
    'PRE-PAGO ZERO-BALANCE': {
        id: 'PRE-PAGO ZERO-BALANCE',
        defaultMessage: 'Zero balance prepaid',
    },
    LENDING: {
        id: 'LENDING',
        defaultMessage: 'Lending',
    },
    MERCHANT: {
        id: 'MERCHANT',
        defaultMessage: 'Merchant',
    },
    'CURRENT ACCOUNTS': {
        id: 'CURRENT ACCOUNTS',
        defaultMessage: 'Current Account',
    },
    'CORRESPONDENT ACCOUNTS': {
        id: 'CORRESPONDENT ACCOUNTS',
        defaultMessage: 'Correspondent Account',
    },
    'INTERNAL ACCOUNTS': {
        id: 'INTERNAL ACCOUNTS',
        defaultMessage: 'Internal Account',
    },
    'CHECKING ACCOUNT': {
        id: 'CHECKING ACCOUNT',
        defaultMessage: 'Checking Account',
    },
});

export default enumMessages;
